export default "__VITE_ASSET__CcZAGYdj__"